import React from 'react';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import BlockContainer from '../BlockContainer';

import css from './BlockAmbassadorText.module.css';

const InstagramIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" stroke="#262338" strokeWidth="1.8" fill="none"/>
    <circle cx="12" cy="12" r="4" stroke="#262338" strokeWidth="1.8" fill="none"/>
    <circle cx="17.5" cy="6.5" r="1.2" fill="#262338"/>
  </svg>
);

const BlockAmbassadorText = props => {
  const {
    blockId,
    className,
    rootClassName,
    ctaButtonClass,
    title,
    text,
    callToAction,
    media,
    responsiveImageSizes,
    options,
    alignment,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const hasMedia = hasDataInFields([media], options);
  const hasCta = hasDataInFields([callToAction], options);
  const alignmentClass = { left: css.alignLeft, center: css.alignCenter, right: css.alignRight }[alignment];

  // Parse text.content to extract quote and instagram handle
  const textContent = text?.content || '';
  const parts = textContent.split(/\n\n+/);
  const quoteText = parts[0]?.trim().replace(/^"|"$/g, '"').replace(/^"|"$/g, '"') || null;
  const handleMatch = textContent.match(/\[(@[^\]]+)\]\((https?:\/\/[^\)]+)\)/);
  const handleText = handleMatch?.[1];
  const handleUrl = handleMatch?.[2];

  return (
    <BlockContainer id={blockId} className={classNames(classes, alignmentClass)}>
      {/* Ambassador name heading */}
      <Field data={title} options={options} />

      {/* Quote */}
      {quoteText ? (
        <p className={css.quote}>{quoteText}</p>
      ) : null}

      {/* Avatar + Instagram icon + handle */}
      {(hasMedia || handleText) ? (
        <div className={css.profileRow}>
          {hasMedia ? (
            <div className={css.avatar}>
              <Field data={media} sizes="80px" options={options} />
            </div>
          ) : null}
          <InstagramIcon />
          {handleText && handleUrl ? (
            <a href={handleUrl} className={css.handle} target="_blank" rel="noopener noreferrer">
              {handleText}
            </a>
          ) : null}
        </div>
      ) : null}

      {/* CTA button */}
      {hasCta ? (
        <Field data={callToAction} className={ctaButtonClass} options={options} />
      ) : null}
    </BlockContainer>
  );
};

export default BlockAmbassadorText;
